import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "./components/shared/Layout";
import RequireAuth from "./components/auth/RequireAuth";
import useSession from "./hooks/useSession";
import PlatformPage from "./pages/PlatformPage";
import { RoutePath } from "./utilities/Constants";
import LocalTransportListPage from "./pages/LocalTransportListPage";
import InterCityListPage from "./pages/products/InterCityListPage";
import WhyUsPage from "./pages/WhyUsPage";
import LoginPage from "./pages/LoginPage";
import InstructionPage from "./pages/products/InstructionPage";
import LocalTransportUniquePage from "./pages/products/LocalTransportUniquePage";
import AddLocalTransport from "./pages/products/AddLocalTransport";
import ContactPage from "./pages/reviews/ContactPage";
import FooterPage from "./pages/footer/FooterPage";
import UniqueReviewPage from "./pages/reviews/UniqueReviewPage";
import AddReviewPage from "./pages/reviews/AddReviewPage";
import ClientListPage from "./pages/clients/ClientListPage";
import AddClientPage from "./pages/clients/AddClientPage";
import UniqueClientPage from "./pages/clients/UniqueClientPage";
import UserAuth from "./components/auth/UserAuth";
import InterCityUniquePage from "./pages/products/InterCityUniquePage";
import AddIntercityTransport from "./pages/products/AddIntercityTransport";
import ManageUsersPage from "./pages/users/ManageUsersPage";
import AdminAuth from "./components/auth/AdminAuth";
import { useEffect, useState } from "react";

function App() {
  const [user] = useSession();
  // Dark mode toggle start
  const [darkMode, setDarkMode] = useState(false);
  function toggleDarkMode() {
    setDarkMode((old) => !old);
  }

  useEffect(() => {
    const isDarkMode = localStorage.getItem("theme") === "dark";
    setDarkMode(isDarkMode);
  }, []);

  useEffect(() => {
    localStorage.setItem("theme", darkMode ? "dark" : "light");
  }, [darkMode]);

  useEffect(() => {
    if (
      localStorage.theme === "dark" ||
      (!("theme" in localStorage) &&
        window.matchMedia("(prefers-color-scheme: dark)").matches)
    ) {
      document.documentElement.classList.remove("dark");
    } else {
      document.documentElement.classList.add("dark");
    }
  }, [darkMode]);
  // Dark mode toggle End

  const {
    platform,
    solutions,
    whyUs,
    login,
    productDetails,
    productList,
    productUnique,
    productAdd,
    clientList,
    clientAdd,
    clientUnique,
    reviewList,
    reviewUnique,
    reviewAdd,
    footer,
    intercityUnique,
    intercityAdd,
    manageUser,
  } = RoutePath;

  return (
    <Routes>
      <Route
        path="/"
        element={
          <RequireAuth>
            <Layout toggleDarkMode={toggleDarkMode} darkMode={darkMode} />
          </RequireAuth>
        }
      >
        <Route
          index
          element={
            <Navigate
              to={user?.role === "admin" ? `/${platform}` : `/${login}`}
            />
          }
        />
        {/* topbar */}
        <Route path={platform} element={<PlatformPage />} />
        {/* local list */}
        <Route path={solutions} element={<LocalTransportListPage />} />
        {/* local add */}
        <Route path={productAdd} element={<AddLocalTransport />} />
        {/* local unique */}
        <Route path={productUnique} element={<LocalTransportUniquePage />} />
        {/* intercity */}
        <Route path={productDetails} element={<InterCityListPage />} />
        {/* InterCity Unique */}
        <Route path={intercityUnique} element={<InterCityUniquePage />} />
        {/* intercity add */}
        <Route path={intercityAdd} element={<AddIntercityTransport />} />
        {/* Instructions */}
        <Route path={productList} element={<InstructionPage />} />
        {/* contact */}
        <Route path={reviewList} element={<ContactPage />} />
        {/* footer */}
        <Route path={footer} element={<FooterPage />} />
        {/* user list page */}
        <Route
          path={manageUser}
          element={
            <AdminAuth>
              <ManageUsersPage />
            </AdminAuth>
          }
        />
      </Route>
      <Route
        path={login}
        element={
          <UserAuth>
            <LoginPage toggleDarkMode={toggleDarkMode} darkMode={darkMode} />
          </UserAuth>
        }
      />
    </Routes>
  );
}

export default App;
